define.alias("shared/components/shared/social/refresh-profile/base-button", "settings/components/shared/social/refresh-profile/base-button");